import { CardProps } from "@mantine/core"
import type { ReactNode } from 'react'

export type DashboardCardProps = CardProps & {
    editing?: boolean;
    cardless?: boolean;
}

export type Crumb =
    | { label: string | ((match: any) => string) }
    | { dynamicLabel: (match?: any) => string }
    | { render: (match: any) => ReactNode }

export const getCrumbContent = (crumb: Crumb, match: any) => {
    if ('render' in crumb) {
        return { content: crumb.render(match), isRich: true as const };
    }

    if ('label' in crumb) {
        return {
            content: typeof crumb.label === 'function' ? crumb.label(match) : crumb.label,
            isRich: false as const,
        };
    }

    return {
        content: crumb.dynamicLabel(match),
        isRich: false as const,
    };
}

export type PageTitle = string | ((match: any) => string)

/**
 * Gets a route's browser-title fragment. Breadcrumb labels provide a useful
 * default, while routes without a breadcrumb can opt in with `staticData.title`.
 */
export const getPageTitle = (match: any): string | undefined => {
    const title = match.staticData?.title as PageTitle | undefined
    if (title) {
        return typeof title === 'function' ? title(match) : title
    }

    const crumb = match.staticData?.crumb as Crumb | undefined
    if (!crumb || 'render' in crumb) return undefined

    if ('label' in crumb) {
        return typeof crumb.label === 'function' ? crumb.label(match) : crumb.label
    }

    return crumb.dynamicLabel(match)
}

declare module '@tanstack/react-router' {
    interface StaticDataRouteOption {
        crumb?: Crumb;
        title?: PageTitle;
        hideFromHistory?: boolean;
    }
}
